import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import UserSummary from './UserSummaryComponent';
import { logout } from 'apex-web/lib/redux/actions/authActions';
import config from 'apex-web/lib/config';

const mapStateToProps = state => {
  const { theme } = config.global;
  const localConfig = JSON.parse(localStorage.getItem('apexTemplate')) || {};

  const currentTheme = localConfig.theme || theme;

  return {
    currentTheme
  };
};

const mapDispatchToProps = {
  logout
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserSummary));
